module.exports = __webpack_public_path__ + "static/img/evolução-convites.71ecc9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolução-convites.png
// module id = C0g1
// module chunks = 1